"use client";
import {
  HeroUIProvider
} from "./chunk-OKNU54ZL.mjs";
import "./chunk-GR3VEF4M.mjs";
import {
  useLabelPlacement
} from "./chunk-2BFF5KFD.mjs";
import {
  ProviderContext,
  useProviderContext
} from "./chunk-Q3W45BN5.mjs";

// src/index.ts
import {
  forwardRef,
  toIterator,
  mapPropsVariants,
  mapPropsVariantsWithCommon,
  isHeroUIEl,
  extendVariants
} from "@heroui/system-rsc";
export {
  HeroUIProvider,
  ProviderContext,
  extendVariants,
  forwardRef,
  isHeroUIEl,
  mapPropsVariants,
  mapPropsVariantsWithCommon,
  toIterator,
  useLabelPlacement,
  useProviderContext
};
